import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentTemplate, TitleHeader } from 'web-library';
import CandidateListingTable from '../../../modules/transaction/@coordinator/CandidateListingTable';
import TransactionDetailsPage from '../CandidateTransactionDetailsListing/TransactionDetailsPage';

interface TransactionPageProps {
  isCoordinator?: boolean;
}

const TransactionPage = ({ isCoordinator = false }: TransactionPageProps) => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('transaction->>Page.Header.Transactions')} />

      <ContentTemplate type="full">
        {isCoordinator ? <CandidateListingTable /> : <TransactionDetailsPage />}
      </ContentTemplate>
    </>
  );
};

export default TransactionPage;
